import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

console.log('[API] Using API URL:', API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    console.log('[API] Request:', config.method?.toUpperCase(), config.url);
    console.log('[API] Token from localStorage:', token ? `${token.substring(0, 20)}...` : 'none');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('[API] Request error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response) => {
    console.log('[API] Response:', response.status, response.config.url);
    return response;
  },
  (error) => {
    console.error('[API] Response error:', error.response?.status, error.config?.url, error.message);
    if (error.response?.status === 401) {
      // Token expired or invalid - but don't redirect for login endpoint
      const isLoginEndpoint = error.config?.url?.includes('/auth/login');
      console.log('[API] 401 error, isLoginEndpoint:', isLoginEndpoint);
      if (!isLoginEndpoint) {
        console.log('[API] Clearing token and redirecting to login');
        localStorage.removeItem('token');
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
